import { DateTime } from 'luxon';
import env from 'environment';

export function toLongTimeStringWithUTCOffset(date, offset) {
    if (date === null) return "";
    let formatted = DateTime.fromISO(date + offset).setLocale(env.locale).toLocaleString(DateTime.DATETIME_MED)
    return formatted;
}

export function fromISOFormat(dateString) {
    return DateTime.fromISO(dateString);
}

export function toFormat(date, format) {
    if (date === null) return "";
    let formatted = "";

    if (typeof date === 'string') {
        formatted = DateTime.fromISO(date).setLocale(env.locale).toLocaleString(format)
    } else if (date.isLuxonDateTime) {
        formatted = date.setLocale(env.locale).toLocaleString(format)
    } else {
        formatted = DateTime.fromJSDate(date).setLocale(env.locale).toLocaleString(format)
    }

    return formatted;
}

export const toShortDateString = date => toFormat(date, DateTime.DATE_SHORT);
export const toShortDateTimeString = date => toFormat(date, DateTime.DATETIME_SHORT);
export const toLongTimeString = date => toFormat(date, DateTime.DATETIME_MED);

export function toShortDateStringWithUTCOffset(date, offset) {
    if (date === null) return "";

    let formatted = DateTime.fromISO(date + offset).setLocale(env.locale).toLocaleString(DateTime.DATETIME_SHORT)

    return formatted;
}

export function toDaysHoursAndMinutes(durationInMinutes, shortForm = true) {
    if (durationInMinutes === null) return "";

    const days = Math.round((durationInMinutes / 60) / 24);
    const hours = Math.floor(durationInMinutes / 60) - (days * 24);
    const minutes = durationInMinutes % 60;

    let result = "";

    if (days > 0) {
        result = `${days} ${shortForm ? 'd' : days > 1 ? 'days' : 'day'} `;
    }

    if (hours > 0) {
        result = result + `${hours} ${shortForm ? 'h' : hours > 1 ? 'hours' : 'hour'} `
    }

    if (minutes > 0) {
        result = result + minutes + ` ${shortForm ? 'm' : minutes > 1 ? 'minutes' : 'minute'}`;
    }

    return result;
}